export default __webpack_public_path__ + "static/img-media-logo-a0b1af39bdea9f93e1c2c54554783cfe.png";